import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Menhir2PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.MENHIR2;
}

export default Menhir2PoiTileEntity;
